<template>
  <div>
    <ViewSelfHelp
      :docPreview="docPreview"
      :docData="viewData"
      @close-docPreview="toggleDocPreview"
    />
    <b-card
      no-body
      class="mt-6"
      v-if="categorywisepages.data && categorywisepages.data.length"
    >
      <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light table-th-color "
        :data="categorywisepages.data"
        border
      >
        <el-table-column label="Self-Help tools" prop="title" sortable>
          <template v-slot="{ row }" class="">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ row.title }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="Date" prop="title" sortable>
          <template v-slot="{ row }" class="">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{
                new Date(row.date).toLocaleDateString(undefined, {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                })
              }}
            </p>
          </template>
        </el-table-column>

        <el-table-column label="Edited By" prop="editedby" sortable>
          <template v-slot="{ row }">
            <p
              class="font-semibold text-left name mb-0 text-sm"
              v-if="row.isEdited"
            >
              {{
                row.editedBy.at(-1)._user.firstname +
                  " " +
                  row.editedBy.at(-1)._user.lastname || " "
              }}
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Images" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.Images }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Attachments" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.Attachments }}
          </p>
        </template>
      </el-table-column> -->

        <el-table-column
          label="Actions"
          min-width="40px"
          class-name="text-center"
        >
          <template slot-scope="scope">
            <div class="flex justify-center items-center">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-6 text-blue-500 cursor-pointer"
                class="mr-2"
                v-b-modal="'docPreview'"
                @click="handleView(scope)"
              ></feather-icon>
              <feather-icon
                icon="EditIcon"
                svgClasses="w-6 text-blue-500 cursor-pointer"
                class="mr-2"
                @click="handleEdit(scope)"
              ></feather-icon>
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-6 text-red-600 cursor-pointer"
                class=""
                @click="handleDelete(scope)"
              ></feather-icon>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total="totalRows"
          @change="handlePageChange"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import Data from "./Data";
import ViewSelfHelp from "./viewSelfHelp.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";

import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    ViewSelfHelp,
  },

  data() {
    return {
      Data,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      categoryId: null,
      docPreview: false,
      viewData: {},
    };
  },
  computed: {
    ...mapState("cms", {
      categorywisepages: "categorywisepages",
      selectedpagecategory: "selectedpagecategory",
      pageCategories: "pageCategories",
    }),
  },
  methods: {
    async resolveCategoryId() {
      if (!this.pageCategories || !this.pageCategories.length) {
        await this.$store.dispatch("cms/getPageCategories");
      }
      const category = (this.pageCategories || []).find(
        (element) =>
          element.route &&
          (element.route.includes("selfhelp") ||
            element.route.includes("self-help-tools"))
      );
      this.categoryId =
        (category && category._id) ||
        (this.selectedpagecategory && this.selectedpagecategory.id) ||
        "61e9547e1a9b68138421810f";
    },
    async fetchSelfhelp() {
      if (!this.categoryId) {
        await this.resolveCategoryId();
      }
      const payload = {
        offset: Math.max(0, (this.currentPage - 1) * this.perPage),
        limit: this.perPage,
        id: this.categoryId,
        updatedAt: true,
      };
      const response = await this.$store.dispatch(
        "cms/getpagebycategory",
        payload
      );
      const pageResult = response && response.data ? response.data : {};
      this.totalRows =
        Number(pageResult.totalPages || pageResult.totalCount) ||
        (pageResult.data && pageResult.data.length) ||
        0;
    },
    handleView(slot) {
      const { row } = slot;
      this.viewData = row;
      this.toggleDocPreview(true);
    },
    async toggleDocPreview(val = false) {
      this.docPreview = val;
    },
    toKebabCase(string) {
      return string.toLowerCase().replace(/\s/g, "-");
    },
    toTitleCase(string) {
      return (
        string &&
        string.slice(0, 1).toUpperCase() + string.slice(1).toLowerCase()
      );
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = row._id;
      let loader = this.$loading();
      try {
        await this.$store.dispatch("cms/deletePage", payload);
        await this.$store.commit("cms/deleteSelfhelp", payload);
        this.totalRows = Math.max(0, this.totalRows - 1);
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      await this.fetchSelfhelp();
    },
    async handleEdit(scope) {
      let { row } = scope;

      this.$router.push({ name: "editselfhelp" });
      await this.$store.commit("cms/SET_SELECTED_BLOG", row);
    },
  },
  async mounted() {
    await this.resolveCategoryId();
    await this.fetchSelfhelp();
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
</style>
